import api from './api';

export const cateringService = {
  // Catering Categories
  async getCategories() {
    const response = await api.get('/catering/categories');
    return response.data;
  },

    async getCategoriesForMainMenu() {
    const response = await api.get('/catering/main_menu/categories');
    return response.data;
  },


  async createCategory(category) {
    const response = await api.post('/catering/categories', category);
    return response.data;
  },

  async updateCategory(id, category) {
    const response = await api.put(`/catering/categories/${id}`, category);
    return response.data;
  },

  async deleteCategory(id) {
    const response = await api.delete(`/catering/categories/${id}`);
    return response.data;
  },

  // Catering Menu Items
  async getMenuItems(categoryId = null) {
    const params = categoryId ? { category_id: categoryId } : {};
    const response = await api.get('/catering/menu-items', { params });
    return response.data;
  },

    async getMenuItemsForMainMenu(categoryId = null) {
    const params = categoryId ? { category_id: categoryId } : {};
    const response = await api.get('/catering/main_menu/menu-items', { params });
    return response.data;
  },

  async createMenuItem(item) {
    try {
      const response = await api.post('/catering/menu-items', item);
      return response.data;
    }
    catch(error){
      // console.log(error)
    }
  
  },

  async updateMenuItem(id, item) {
    const response = await api.put(`/catering/menu-items/${id}`, item);
    return response.data;
  },

  async deleteMenuItem(id) {
    const response = await api.delete(`/catering/menu-items/${id}`);
    return response.data;
  },

  // Complete Menu
  async getCateringMenu() {
    const response = await api.get('/catering/menu');
    return response.data;
  },

  // Catering Main Menus
  async getMainMenus() {
    const response = await api.get('/catering/main-menus');
    return response.data;
  },

  async createMainMenu(formData) {
    try {
      // Try with multipart form data first (with image)
      const response = await api.post('/catering/main-menus', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      // If form data fails, try JSON approach without image
      if (formData instanceof FormData) {
        const jsonData = {
          name: formData.get('name'),
          description: formData.get('description'),
          price_per_person: parseFloat(formData.get('price_per_person')),
          minimum_guests: parseInt(formData.get('minimum_guests')),
          maximum_guests: formData.get('maximum_guests') ? parseInt(formData.get('maximum_guests')) : null,
          preparation_time_hours: parseInt(formData.get('preparation_time_hours')),
          is_available: formData.get('is_available') === 'true',
          is_active: formData.get('is_active') === 'true',
          sort_order: parseInt(formData.get('sort_order')),
        };

        const response = await api.post('/catering/main-menus-json', jsonData);
        return response.data;
      }
      throw error;
    }
  },

  async updateMainMenu(id, formData) {
    // console.log("Form Data = ", formData);
    try {
      // First try with multipart/form-data (with image support)
      const response = await api.put(`/catering/main-menus/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      // Only fall back to JSON when no image file is provided
      const hasImage = formData instanceof FormData && formData.get('image');
      if (!hasImage && (error.response?.status === 400 || error.response?.status === 422)) {
        const jsonData = {
          name: formData.get('name'),
          description: formData.get('description'),
          price_per_person: parseFloat(formData.get('price_per_person')),
          minimum_guests: parseInt(formData.get('minimum_guests')),
          maximum_guests: formData.get('maximum_guests') ? parseInt(formData.get('maximum_guests')) : null,
          preparation_time_hours: parseInt(formData.get('preparation_time_hours')),
          is_available: String(formData.get('is_available')) === 'true',
          is_active: String(formData.get('is_active')) === 'true',
          sort_order: parseInt(formData.get('sort_order')),
        };
        const response = await api.put(`/catering/main-menus-json/${id}`, jsonData);
        return response.data;
      }
      throw error;
    }
  },

  async deleteMainMenu(id) {
    const response = await api.delete(`/catering/main-menus/${id}`);
    return response.data;
  },

  async addItemToMainMenu(menuId, item) {
    const response = await api.post(`/catering/main-menus/${menuId}/items`, item);
    return response.data;
  },

  async removeItemFromMainMenu(menuId, itemId) {
    const response = await api.delete(`/catering/main-menus/${menuId}/items/${itemId}`);
    return response.data;
  },

  // Public Endpoints
  async getPublicMainMenus() {
    const response = await api.get('/catering/public/main-menus');
    return response.data;
  },

  async getPublicMainMenuDetails(menuId) {
    const response = await api.get(`/catering/public/main-menus/${menuId}/details`);
    return response.data;
  },

  async createCateringRequest(requestData) {
    const response = await api.post('/catering/public/requests', requestData);
    return response.data;
  },

  // Admin Catering Requests
  async getCateringRequests() {
    const response = await api.get('/catering/requests');
    // console.log("Request API Happened => " , response.data);
    return response.data;
  },

   async getUpdatedCateringRequests(queryParams = '') {
      const url = queryParams 
    ? `/catering/updated-requests?${queryParams}` 
    : '/catering/updated-requests';
  
    const response = await api.get(url);
    // console.log("Updated Requests API Called with params:", queryParams);
    return response.data;
},

  async getSpecificCateringRequest(id) {
    const response = await api.get(`/catering/get_request/${id}`);
    return response.data;
  },


  async updateCateringRequest(id, updateData) {
    const response = await api.patch(`/catering/requests/${id}`, updateData);
    return response.data;
  },

  // Catering Payment Methods
  async getPaymentOptions(requestId) {
    const response = await api.get(`/catering/requests/${requestId}/payment-options`);
    return response.data;
  },

  async createPayment(requestId, paymentData) {
    const response = await api.post(`/catering/requests/${requestId}/pay`, paymentData);
    return response.data;
  },

  async getPaymentStatus(paymentId) {
    const response = await api.get(`/catering/payments/${paymentId}/status`);
    return response.data;
  },

  async getRequestPayments(requestId) {
    const response = await api.get(`/catering/requests/${requestId}/payments`);
    return response.data;
  },

  async getaddonItems() {
    const response = await api.get(`/catering/get_add_on_items`);
    return response.data;
  },

  async getMenuItemsByMainMenu(main_menu_id){
    const response = await api.get(`/catering/main_menu_items/${main_menu_id}`)
    return response.data;
  },

  async menuItemsSorting(payload,id){
    const response = await api.post(`/catering/menu_item/sort/${id}`, payload)
    return response.data 
  },

  async getMenuItemsForSort(main_menu_id){
    const response = await api.get(`/catering/sort/get_main_menu_items/${main_menu_id}`)
    return response.data 
  },

  async updateRequestStatus(request_id,status_update){
    const response = await api.put(`/catering/update_request/${request_id}`,status_update);
    return response.data 
  },
};


